import TilesPrayerCard from "../tiles-prayer-card/TilesPrayerCard";
import { ITimedEvent } from "@/helpers/format-prayer-tide";

import "./style.scss";

type TilesPrayerContentProps = {
	data: ITimedEvent[];
	showCurrentType: boolean;
};

export const TilesPrayerContent = ({
	data,
	showCurrentType,
}: TilesPrayerContentProps) => {
	const getCurrentEvent = (): ITimedEvent | null => {
		const now = new Date();
		const nowMinutes = now.getHours() * 60 + now.getMinutes();

		let latest: ITimedEvent | null = null;

		for (const item of data) {
			const [hours, minutes] = item.time24h
				.replace(/[^\d:]/g, "")
				.split(":")
				.map(Number);

			const eventMinutes = hours * 60 + minutes;

			if (eventMinutes <= nowMinutes) {
				if (!latest) {
					latest = item;
				} else {
					const [lh, lm] = latest.time24h
						.replace(/[^\d:]/g, "")
						.split(":")
						.map(Number);

					if (eventMinutes > lh * 60 + lm) {
						latest = item;
					}
				}
			}
		}

		return latest;
	};

	const type: "upwelling" | "downwelling" = getCurrentEvent()?.label.includes(
		"High",
	)
		? "downwelling"
		: "upwelling";

	return (
		<div className="tiles-prayer-content">
			{data.map((item) => (
				<TilesPrayerCard key={item.label} data={item} />
			))}
			{showCurrentType && <TilesPrayerCard currentType={type} />}
		</div>
	);
};

export default TilesPrayerContent;
